/*
Principles: the heading holds while the three statements travel past it.

The hold is CSS position:sticky, not a GSAP pin. It costs nothing, it survives
with JavaScript off, and it does not fight the reveal. What GSAP adds here is the
weighting: the statement nearest the middle of the screen is at full strength and
the others sit back, so the section reads as a sequence rather than a list.
*/

export function principles(gsap) {
  const items = gsap.utils.toArray('.principle');

  if (items.length < 2) return;

  items.forEach((item) => {
    gsap.fromTo(item, { opacity: 0.38 }, {
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: item,
        start: 'top 78%',
        end: 'center 42%',
        scrub: 0.5,
      },
    });
  });
}
